/* Imports */
import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import axios from "axios";
import Footer from '../component/footer';
import BannerSlider from '../component/common/bannerSlider';
import "../styles/Race.css";
import * as RACE from "../constant/Race.js";

const Race = () => {
    /* Constants */
    let screenWidth = window.innerWidth;

    /* Refs */
    const uspRef = useRef(null);
    const bannerRef = useRef(null);
    const faqTncRef = useRef(null);

    /* Use States */
    const [uspVisible, setUspVisible] = useState(false);
    const [bannerVisible, setBannerVisible] = useState(false);
    const [faqTncVisible, setFaqTncVisible] = useState(false);
    const [dynamicTheme, setDynamicTheme] = useState({});
    const [setting, setSetting] = useState({});
    const [iconList, setIconList] = useState([]);
    const [bannerImageList, setBannerImageList] = useState([]);
    const [mobileBannerImageList, setMobileBannerImageList] = useState([]);
    const [carouselList, setCarouselList] = useState([]);

    /* Use Effects */
    // Get theme color
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await axios.get(`${RACE.API_URL}/api/onlinestore/getDetailsByCategory`, { params: { category: 'onex5g' } });

                if (res.message != 1000) {
                    let settingInfo = res.data.result.setting;

                    setDynamicTheme(settingInfo.theme);
                    setSetting(settingInfo);
                    // setIconList(settingInfo.icons);
                    // setBannerImageList(settingInfo.banners);
                    // setMobileBannerImageList(settingInfo.mobileBanners);
                    setIconList(RACE.ICON_LIST);
                    setBannerImageList(RACE.BANNER_IMAGE_LIST);
                    setMobileBannerImageList(RACE.MOBILE_BANNER_IMAGE_LIST);
                }
            } catch (err) {
                console.error("Error fetching settings:", err);
            }
        };

        fetchSettings();
    }, []);

    // Handle fade in animation for USP section
    useEffect(() => {
        const timer = setTimeout(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setUspVisible(true);
                        observer.disconnect();
                    }
                },
                {
                    threshold: 0.2,
                }
            );

            if (uspRef.current) {
                observer.observe(uspRef.current);
            }
        }, 200);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    // Handle fade in animation for Banner section
    useEffect(() => {
        const timer = setTimeout(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setBannerVisible(true);
                        observer.disconnect();
                    }
                },
                {
                    threshold: 0.2,
                }
            );

            if (bannerRef.current) {
                observer.observe(bannerRef.current);
            }
        }, 200);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    // Handle fade in animation for FAQ and TNC section
    useEffect(() => {
        const timer = setTimeout(() => {
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setFaqTncVisible(true);
                        observer.disconnect();
                    }
                },
                {
                    threshold: 0.3,
                }
            );

            if (faqTncRef.current) {
                observer.observe(faqTncRef.current);
            }
        }, 200);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    /* Components */
    const TopBanner = () => {
        if ((screenWidth > 500 && bannerImageList.length <= 0) ||
            (screenWidth <= 500 && mobileBannerImageList.length <= 0)) return null

        return <BannerSlider shadow={true} images={screenWidth > 500 ? bannerImageList : mobileBannerImageList} />
    }

    const USP = () => {
        return (
            <div ref={uspRef} className={`fadeInAnimation ${uspVisible ? 'show' : ''}`} style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: screenWidth > 768 ? '2%' : '4%' }}>
                    {
                        setting.titleLogo ?
                            <img className="dynamicTitleLogo" style={{ width: 'auto' }} src={RACE.ICON_XOX} alt="xox_5g_logo" />
                            :
                            null
                    }
                    {/* <div className={"boldText " + (screenWidth > 500 ? "collosalText40" : "collosalText38")} style={{ marginLeft: screenWidth > 500 ? '18.85px' : '4.0109%' }}>
                                {setting.title}
                            </div> */}
                </div>
                <div className="collosalText labelText" style={{ whiteSpace: 'pre-wrap', width: '64%', lineHeight: 1.5, textAlign: 'center', marginBottom: carouselList.length > 0 ? (screenWidth > 768 ? '3.8542%' : '8.2513%') : '40px' }}>
                    {/* {setting.description} */}
                    Power up with XOX 5G and fuel your race-day dreams. <br></br>Every top-up or bill payment minimum RM30 brings you closer to winning an unforgettable Grandstand Experience.
                </div>

                <button className="semiBoldText montserrat joinRaceBtn" style={{ width: '286px' }}
                    onClick={() => window.location.href = RACE.ONLINESTORE_POSTPAID_5G_URL}
                >
                    <span>Join The Race</span>
                </button>

                {
                    (iconList.length <= 0) ?
                        <div style={{ marginTop: '30px' }} />
                        :
                        <div className={iconList.length > 3 ? "iconContainer1" : "iconContainer2"}>
                            {
                                iconList.map((item, index) => {
                                    return <div key={index} className="iconConsistentWidth"><img className={item.includes('valueplan') ? "iconItem4" : "iconItem3"} src={item} alt="icon" /></div>
                                })
                            }
                        </div>
                }
            </div>
        )
    }

    const DetailsBanner = () => {
        return (
            <div ref={bannerRef} className={`fadeInAnimation ${bannerVisible ? 'show' : ''}`} style={{ display: 'flex', justifyContent: 'center' }}>
                <img style={{ ...styles.detailsBanner }} src={RACE.BANNER_DETAILS} alt="details_banner" />
            </div>
        )
    }

    const FaqTnc = () => {
        return (
            <div ref={faqTncRef} className={`fadeInAnimation ${faqTncVisible ? 'show' : ''}`} style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                <div className="collosalText labelText" style={{ fontWeight: 'bold', lineHeight: 1.5, textAlign: 'center', margin: '40px 0' }}>
                    Don't Miss Out! <br></br>Campaign Ends 27 September 2026.
                </div>

                <button className="semiBoldText montserrat joinRaceBtn" style={{ width: '286px' }}
                    onClick={() => window.location.href = RACE.ONLINESTORE_POSTPAID_5G_URL}
                >
                    <span>Join The Race</span>
                </button>

                <div style={{ width: '100%', marginTop: screenWidth > 768 ? '5%' : '10%', textAlign: 'center' }}>
                    <div className='collosalText40 boldText' >Have A Question?</div>
                    <div className='collosalText' style={{ margin: '8px 7% 10px 7%', fontSize: screenWidth > 768 ? '24px' : '14px', fontWeight: '600' }}>Refer to this section for guidance.</div>
                </div>

                <div style={{ ...styles.haveAQuestion, marginTop: screenWidth > 768 ? '1rem' : '20px' }}>
                    <div className="faq-container">
                        <div className="faq-card-wrapper">
                            <div className="faq-card">
                                <div className="faq-title">
                                    Frequently Asked Questions
                                </div>

                                <button
                                    className="faq-button blackHoverBG largeText whiteHoverText"
                                    onClick={() => {
                                        window.location.href = RACE.FAQ;
                                    }}
                                >
                                    <b>Read More</b>
                                </button>

                                <div className="faq-watermark">FAQs</div>
                            </div>
                        </div>

                        <div className="faq-card-wrapper">
                            <div className="faq-card">
                                <div className="faq-title">
                                    Terms & Conditions
                                </div>

                                <button
                                    className="faq-button blackHoverBG largeText whiteHoverText"
                                    onClick={() => {
                                        window.location.href = RACE.TNC;
                                    }}
                                >
                                    <b>Read More</b>
                                </button>

                                <div className="faq-watermark">T&Cs</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='montserrat dynamicTheme onlinestoreMain' style={{ ...dynamicTheme, "--screenWidth": screenWidth }}>
            <div className={'mainContainer'} >
                {TopBanner()}
                <div className='mainDiv'
                    style={{ ...styles.mainBgDiv, backgroundImage: (dynamicTheme && dynamicTheme.mainBgImg) ? `url(${dynamicTheme.mainBgImg})` : `url(${RACE.MAIN_BG_IMAGE})` }}>
                    {USP()}
                    {DetailsBanner()}
                    {FaqTnc()}
                    <div style={{ padding: "0px 5.208vw", marginTop: screenWidth > 768 ? '5%' : '10%', width: '100%' }}>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    )
};

const styles = {
    mainBgDiv: {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
    },
    detailsBanner: {
        width: '90%',
        borderRadius: '15px',
    },
    haveAQuestion: {
        width: '90%',
        maxWidth: '1220px',
        margin: 'auto',
        alignItems: 'center',
    },
};

export default Race;